$(document).on('change', '.variant-picker__option-values input[type="radio"]', function () {
  var $label = $(this).next('label');
  var currentPrice = $label.find('.current-price').text().trim();
  var comparePrice = $label.find('.compare-price').text().trim();
  var discountTag = $label.find('.discot-tag').text().trim();
  var $productPrice = $('.product-price');
  $productPrice.find('.ogprice').text(currentPrice || '');
  if (comparePrice) {
    $productPrice.find('.cmprice').text(comparePrice).show();
  } else {
    $productPrice.find('.cmprice').hide();
  }
  if (discountTag) {
    $productPrice.find('.discount').text(discountTag).show();
  } else {
    $productPrice.find('.discount').hide();
  }
});
